import React, { useState } from 'react';
import { useLoginModalContext } from '../../context/LoginModalContext';
import './LoginModal.css';
import LoginModalEmail from './LoginModalEmail';
import LoginModalVerification from './LoginModalVerification';
import LoginModalPassword from './LoginModalPassword';
import LoginModalNewPassword from './LoginModalNewPassword';
import LoginModalResetPassword from './LoginModalResetPassword';
import LoginModalResetPasswordCode from './LoginModalResetPasswordCode';
import UserRegistrationModal from './LoginModalRegister';

interface LoginModalProps {
  onClose: () => void;
  onLogin: (email: string) => void;
  onRegister: (email: string) => void
}

export type LoginStep = 'email' | 'verification' | 'password' | 'new_password' | 'register' | 'reset-password' | 'reset-password-code';

const LoginModal: React.FC<LoginModalProps> = ({ 
  onClose, 
  onLogin,
  onRegister
}) => {

  const { currentStep} = useLoginModalContext();

  return (
    <>
      {currentStep === 'email' && <LoginModalEmail onClose={onClose} />}
      {currentStep === 'verification' && <LoginModalVerification onClose={onClose} />}
      {currentStep === 'password' && <LoginModalPassword onClose={onClose} onLogin={onLogin} />}
      {currentStep === 'new_password' && <LoginModalNewPassword onClose={onClose} />}
      {currentStep === 'reset-password' && <LoginModalResetPassword onClose={onClose} />}
      {currentStep === 'reset-password-code' && <LoginModalResetPasswordCode onClose={onClose} />}
      {currentStep === 'register' && <UserRegistrationModal onClose={onClose} onRegister={onRegister}/>}
    </>
  );
};

export default LoginModal;
